import { useEffect } from 'react';
import { handleMapClick, handleSelectPoint } from '../MapMarkers';
import { POINTS_CIRCLE_LAYER } from '../constants';
import { isMapClickAddPointEnabled, isPointSelectionEnabled } from '../../Services';

export const useMapInteractions = ({
  map,
  mapReady,
  sourcesReadyRef,
  isMountedRef,
  currentMode,
  setupSubmode,
  locations,
  setLocations,
  mapPointSelectCallback
}) => {
  // Map click event listener - add new points
  useEffect(() => {
    if (!map.current || !mapReady || !sourcesReadyRef.current || !isMountedRef.current) return;
    
    const mapClickHandler = (e) => {
      handleMapClick(e, {
        currentMode,
        setupSubmode,
        locations,
        setLocations
      });
    };
    
    // Use service function to determine if map click to add points should be enabled
    if (isMapClickAddPointEnabled(currentMode, setupSubmode)) {
      map.current.on('click', mapClickHandler);
    } else {
      map.current.off('click', mapClickHandler);
    }
    
    return () => {
      if (map.current) {
        map.current.off('click', mapClickHandler);
      }
    };
  }, [currentMode, setupSubmode, locations, setLocations, mapReady]);

  // Click on existing marker points
  useEffect(() => {
    if (!map.current || !mapReady || !sourcesReadyRef.current || !isMountedRef.current) {
      return;
    }
    
    // 🔧 Add micro delay to ensure map and callbacks are ready
    const setupClickHandler = () => {
      const pointClickHandler = (e) => {
        handleSelectPoint(e, {
          currentMode,
          locations,
          onMapPointSelect: mapPointSelectCallback
        });
      };
      
      // Use service function to determine if point selection is allowed
      if (isPointSelectionEnabled(currentMode) && mapPointSelectCallback) {
        map.current.on('click', POINTS_CIRCLE_LAYER, pointClickHandler);
      } else {
        map.current.off('click', POINTS_CIRCLE_LAYER, pointClickHandler);
      }
      
      return pointClickHandler;
    };
    
    // Add small delay to ensure all dependencies are ready
    const timeoutId = setTimeout(setupClickHandler, 10);
    
    return () => {
      clearTimeout(timeoutId);
      if (map.current) {
        map.current.off('click', POINTS_CIRCLE_LAYER);
      }
    };
  }, [currentMode, locations, mapPointSelectCallback, mapReady]);
}; 